module.exports = __webpack_public_path__ + "images/on-promo-black-59774071.svg";